var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFA031"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08967 14V7.45455H10.905V14H9.08967ZM10.0016 6.6108C9.73171 6.6108 9.50018 6.52131 9.307 6.34233C9.11665 6.16051 9.02148 5.94318 9.02148 5.69034C9.02148 5.44034 9.11665 5.22585 9.307 5.04688C9.50018 4.86506 9.73171 4.77415 10.0016 4.77415C10.2715 4.77415 10.5016 4.86506 10.6919 5.04688C10.8851 5.22585 10.9817 5.44034 10.9817 5.69034C10.9817 5.94318 10.8851 6.16051 10.6919 6.34233C10.5016 6.52131 10.2715 6.6108 10.0016 6.6108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic_warning.d8519d1553d8a424019b60d524bc8767.svg";
export { ForwardRef as ReactComponent };